import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguage } from '../helpers/i18n';
import { TRANSLATIONS_SP } from './spanish/translation';
import { TRANSLATIONS_EN } from './english/translation';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: TRANSLATIONS_SP,
      },
      en: {
        translation: TRANSLATIONS_EN,
      },
    },
    lng: getLanguage(),
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
